export const selectTickets = (state) => state.kanban.tickets;
export const selectUsers = (state) => state.kanban.users;
export const selectFilters = (state) => state.kanban.filters;
